import React from "react";
import { connect } from "react-redux";

import { Loader } from "../../../../../core/atoms/loader";
import { ReviewForm } from "../../../../../shared/components/forms/review/reviewForm";
import { ActionPromises } from "../../../../state/actionPromises";

import "./review.scss";

interface StateProps {
  lto: IState<ILto>;
  customerEnquiry: IState<IEnquiry>;
  rrfState: Forms.WebFormRoot;
  user: IState<IUser>;
}

interface DispatchProps {
  createReview: (review: IReviewInput) => Promise<IReview>;
  reloadEnquiry: (enquiryId: number) => void;
  dispatch: any;
}

type Props = DispatchProps & StateProps;

class CustomerEnquiryReviewComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  private saveReview = async (review: IReviewInput) => {
    try {
      await this.props.createReview(review);
      await this.props.reloadEnquiry(this.props.customerEnquiry.data.id);
    }
    catch (e) {
      window.scrollTo(0, 0);
      throw e;
    }
  }

  public render() {
    if (this.props.customerEnquiry.status !== "OK") {
      return <Loader />;
    }

    if (this.props.customerEnquiry.data.reviewed) {
      return (
        <div className="width-wrapper p-top-medium customer-enquiry-review">
          <h1>Thanks for your review</h1>
          <p>You have already reviewed this trip.</p>
        </div>
      );
    }
    else {
      return (
        <div className="width-wrapper p-top-medium customer-enquiry-review">
          <h1>Review your trip</h1>
          <p>We would really appreciate if you took the time to review your holiday with {this.props.lto.data.name}! We may publish this review on our website to help future travellers.</p>

          <ReviewForm
            lto={this.props.lto.data}
            dispatch={this.props.dispatch}
            rrfState={this.props.rrfState}
            enquiry={this.props.customerEnquiry.data}
            userType={this.props.user.data.userType}
            submissionText="Thanks a lot for taking the time to fill this out. We know forms can be boring, but your feedback really does help us do what we do better!"
            submitBtnText="Submit your review"
            submit={this.saveReview}
          />

        </div>
      );
    }
  }
}

const stateToProps = (state: IWebStoreState): StateProps => {
  return {
    lto: state.lto,
    customerEnquiry: state.customerEnquiry,
    rrfState: state.forms,
    user: state.user,
  };
};

const dispatchToProps = (dispatch): DispatchProps => {
  return {
    createReview: (review: IReviewInput) => dispatch(ActionPromises.createReview(review)),
    reloadEnquiry: (enquiryId: number) => dispatch(ActionPromises.enquiryById(enquiryId)),
    dispatch,
  };
};

export const Review = connect(stateToProps, dispatchToProps)(CustomerEnquiryReviewComponent);
